<template>
  <section class="radio-bar-inputs">
    <section-title>RadioBarInput Component</section-title>
    <form-wrap>
      <form-field-set>

        <radio-bar-input
          v-model="radioBarInput"
          :options="options"
          name="radioBarInput1"
        />

      </form-field-set>
    </form-wrap>
  </section>
</template>

<script>
import FormFieldSet from '@/components/forms/FormFieldSet'
import FormWrap from '@/components/forms/FormWrap'
import RadioBarInput from '@/components/forms/RadioBarInput'
import SectionTitle from '@/components/ui/SectionTitle'

export default {
  name: 'RadioBarInputs',
  components: {
    FormFieldSet,
    FormWrap,
    RadioBarInput,
    SectionTitle
  },
  data () {
    return {
      radioBarInput: ''
    }
  },
  computed: {
    options () {
      return [
        { isWarning: true, icon: 'circle', value: 'negative' },
        { isWarning: false, icon: 'eye', value: 'neutral' },
        { isWarning: false, icon: 'pencil-alt', value: 'positive' }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/playground/RadioBarInputs.vue